module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "290",
      "persistent": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-card-text', {
    staticClass: "text-md-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-actions', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.sbmtText))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb3c8216","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/ConfirmationDialog.vue
// module id = 1022
// module chunks = 1